/* eslint-disable no-undef */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-multi-assign */
/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
// fbpixel functionality
import { isGlobalCheck } from 'src/utils/globalCheckHelper';
import { fbqDeferredEventsTrack } from '../../scripts/thirdPartyScripts';

export function fbpixel() {
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod(...arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );
  const FB_PIXEL_ID = getFBPixelID();
  fbq('init', FB_PIXEL_ID);
  fbq('track', 'PageView');
  fbqDeferredEventsTrack();
  // creating noscript tag
  const noScript = document.createElement('noscript');
  const imgTag = document.createElement('img');
  imgTag.height = 1;
  imgTag.width = 1;
  imgTag.style.display = 'none';
  imgTag.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`;
  noScript.appendChild(imgTag);
  // appending noscript tag to the document's head
  document
    .querySelectorAll('script')[0]
    .parentNode.insertBefore(noScript, document.querySelectorAll('script')[0]);
}

export function getFBPixelID() {
  const pathName = window.location.pathname;
  if (isGlobalCheck(pathName)) {
    return process.env.NEXT_PUBLIC_GLOBAL_FBPIXEL_ID;
  } else {
    return process.env.NEXT_PUBLIC_FBPIXEL_ID;
  }
}
